import {computed, ref} from 'vue';

export default function useFilteredLibrary(store) {
    const searchTerm = ref('');

    const filteredLibrary = computed(() => {
        let filtered = store.allLibrary;

        const term = searchTerm.value.trim().toLowerCase();
        if (term) {
            filtered = filtered.filter(quest => {
                return (
                    quest.name && quest.name.toLowerCase().includes(term) ||
                    (quest.description && quest.description.toLowerCase().includes(term))
                );
            });
        }

        return filtered;
    });

    return {filteredLibrary, searchTerm};
}
